/**
 * Stable CSS class names for E2E — SsrsPageManagement page and its dialogs.
 * Containers use `ssrs-page-management__<element>`; inputs and
 * user-interactable controls use `ssrs-page-management-input--<name>`.
 */
export const SSRS = {
    page: 'ssrs-page-management-page',
    root: 'ssrs-page-management',

    /* --- Page header / actions ------------------------------------------ */
    header: 'ssrs-page-management__header',
    title: 'ssrs-page-management__title',
    headerActions: 'ssrs-page-management__header-actions',
    btnAddReport: 'ssrs-page-management-input--button-add-report',

    /* --- Search bar / grid ---------------------------------------------- */
    searchBox: 'ssrs-page-management__search-box',
    inputSearch: 'ssrs-page-management-input--search',

    grid: 'ssrs-page-management__grid',

    cellReportId: 'ssrs-page-management__cell-report-id',
    cellReportTitle: 'ssrs-page-management__cell-report-title',
    cellRole: 'ssrs-page-management__cell-role',
    btnOpenRoleDialog: 'ssrs-page-management-input--button-open-role-dialog',
    cellEdit: 'ssrs-page-management__cell-edit',
    btnEditReport: 'ssrs-page-management-input--button-edit-report',
    cellDelete: 'ssrs-page-management__cell-delete',
    btnDeleteReport: 'ssrs-page-management-input--button-delete-report',

    /* --- Report dialog -------------------------------------------------- */
    reportDialog: 'ssrs-page-management__report-dialog',
    reportDialogTitle: 'ssrs-page-management__report-dialog-title',
    reportDialogForm: 'ssrs-page-management__report-dialog-form',
    reportDialogContent: 'ssrs-page-management__report-dialog-content',
    inputReportTitle: 'ssrs-page-management-input--report-title',
    inputReportUri: 'ssrs-page-management-input--report-uri',
    reportDialogActions: 'ssrs-page-management__report-dialog-actions',
    btnReportSave: 'ssrs-page-management-input--button-report-save',
    btnReportUpdate: 'ssrs-page-management-input--button-report-update',
    btnReportCancel: 'ssrs-page-management-input--button-report-cancel',

    /* --- Role management dialog ----------------------------------------- */
    roleDialog: 'ssrs-page-management__role-dialog',
    roleDialogTitle: 'ssrs-page-management__role-dialog-title',
    roleDialogContentRoot: 'ssrs-page-management__role-dialog-content-root',
    roleDialogForm: 'ssrs-page-management__role-dialog-form',
    roleDialogContent: 'ssrs-page-management__role-dialog-content',
    roleFormControl: 'ssrs-page-management__role-form-control',
    inputRoleSelect: 'ssrs-page-management-input--role-select',
    roleChipsBox: 'ssrs-page-management__role-chips-box',
    roleChip: 'ssrs-page-management__role-chip',
    roleMenuItem: 'ssrs-page-management__role-menu-item',
    roleMenuItemCheckbox: 'ssrs-page-management-input--role-menu-item-checkbox',
    roleMenuItemText: 'ssrs-page-management__role-menu-item-text',
    roleDialogActions: 'ssrs-page-management__role-dialog-actions',
    btnRoleUpdate: 'ssrs-page-management-input--button-role-update',
    btnRoleCancel: 'ssrs-page-management-input--button-role-cancel',
} as const;

export const ssrsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
